import dynamic from "next/dynamic";
const PlainClassicTestimonialsComponent = dynamic(()=>import("./plain-classic-testimonials-component"));
import PlainClassicTestimonialsConfig from "./plain-classic-testimonials-config";
import PlainClassicTestimonialsAdvancedConfig from "./plain-classic-testimonials-advanced-config";
export default {
    PlainClassicTestimonialsComponent,
    PlainClassicTestimonialsConfig,
    PlainClassicTestimonialsAdvancedConfig
};
